import { defineComponent as i, openBlock as t, createElementBlock as o, mergeProps as p, unref as e, renderSlot as u, createElementVNode as n, createCommentVNode as a } from "vue";
import { useScalarIcon as M } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, g = { key: 1 }, m = { key: 2 }, f = { key: 3 }, k = { key: 4 }, h = { key: 5 }, w = {
  name: "ScalarIconMusicNote"
}, b = /* @__PURE__ */ i({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(s) {
    const r = s, { bind: V, weight: A } = M(r);
    return (d, l) => (t(), o("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(V)), [
      u(d.$slots, "default"),
      e(A) === "bold" ? (t(), o("g", Z, l[0] || (l[0] = [
        n("path", { d: "M211.45,52.51l-80-24A12,12,0,0,0,116,40V140.22A52,52,0,1,0,140,184V104.13l64.55,19.36A12,12,0,0,0,220,112V64A12,12,0,0,0,211.45,52.51ZM88,212a28,28,0,1,1,28-28A28,28,0,0,1,88,212ZM196,95.87l-56-16.8V56.13l56,16.8Z" }, null, -1)
      ]))) : e(A) === "duotone" ? (t(), o("g", g, l[1] || (l[1] = [
        n("path", {
          d: "M128,184a40,40,0,1,1-40-40A40,40,0,0,1,128,184Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M210.3,56.34l-80-24A8,8,0,0,0,120,40V148.26A48,48,0,1,0,136,184V98.75l69.7,20.91A8,8,0,0,0,216,112V64A8,8,0,0,0,210.3,56.34ZM88,216a32,32,0,1,1,32-32A32,32,0,0,1,88,216ZM200,101.25l-64-19.2V50.75L200,70Z" }, null, -1)
      ]))) : e(A) === "fill" ? (t(), o("g", m, l[2] || (l[2] = [
        n("path", { d: "M210.3,56.34l-80-24A8,8,0,0,0,120,40V148.26A48,48,0,1,0,136,184V98.75l69.7,20.91A8,8,0,0,0,216,112V64A8,8,0,0,0,210.3,56.34Z" }, null, -1)
      ]))) : e(A) === "light" ? (t(), o("g", f, l[3] || (l[3] = [
        n("path", { d: "M209.72,58.25l-80-24A6,6,0,0,0,122,40V153.05A46,46,0,1,0,134,184V96.06l72.28,21.69A6,6,0,0,0,214,112V64A6,6,0,0,0,209.72,58.25ZM88,218a34,34,0,1,1,34-34A34,34,0,0,1,88,218ZM202,103.94l-68-20.4V48.06l68,20.4Z" }, null, -1)
      ]))) : e(A) === "regular" ? (t(), o("g", k, l[4] || (l[4] = [
        n("path", { d: "M210.3,56.34l-80-24A8,8,0,0,0,120,40V148.26A48,48,0,1,0,136,184V98.75l69.7,20.91A8,8,0,0,0,216,112V64A8,8,0,0,0,210.3,56.34ZM88,216a32,32,0,1,1,32-32A32,32,0,0,1,88,216ZM200,101.25l-64-19.2V50.75L200,70Z" }, null, -1)
      ]))) : e(A) === "thin" ? (t(), o("g", h, l[5] || (l[5] = [
        n("path", { d: "M209.15,60.17l-80-24A4,4,0,0,0,124,40V158.75A44,44,0,1,0,132,184V93.38l74.85,22.45A4,4,0,0,0,212,112V64A4,4,0,0,0,209.15,60.17ZM88,220a36,36,0,1,1,36-36A36,36,0,0,1,88,220ZM204,106.62,132,85V45.38L204,67Z" }, null, -1)
      ]))) : a("", !0)
    ], 16));
  }
});
export {
  b as default
};
